import baseUrlOf from './baseUrlOf';
import hostOf from './hostOf';
import protocolOf from './protocolOf';
import redirect from './redirect';
import fetchOpts from './fetch';
import sanitizeCanonical from './sanitizeCanonical';

const Ssr = { baseUrlOf, protocolOf, hostOf, sanitizeCanonical };

export default Ssr;
export {
  baseUrlOf,
  protocolOf,
  hostOf,
  redirect,
  fetchOpts,
  sanitizeCanonical
};
